<mat-form-field appearance="legacy" class="w-100">
  <mat-label>{{ name }}</mat-label>
  <mat-select [(ngModel)]="selected" name="option" (ngModelChange)="emit()" [disabled]="ngDisabled"
    [multiple]="multiple">
    <mat-option>Todas</mat-option>
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option }}
    </mat-option>
  </mat-select>
</mat-form-field>